
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "./services/auth.service";
import * as moment from "moment";
import { MatDialog } from "@angular/material/dialog";
import { CommonService } from "./services/common.service";
import { environment } from "src/environments/environment";
import { filter } from "rxjs/operators";

const MAPPING_PRINT_OS_LANGUAGE_CONFIG_CENTER = {
  'zh-HANS': 'zh',
  'ZH-CN':'zh',
  'en-GB': 'en',
  'en-US': 'en',
  'fr-FR': 'fr',
  'de-DE': 'de',
  'it-IT': 'it',
  'ja-JP': 'ja',
  'ko-KO': 'ko',
  'pt-PT': 'pt',
  'pt-BR':'pt',
  'es-ES': 'es',
  'es-XN': 'es'
};

declare var gtag;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  gtag_code = environment?.gtag_code;
  constructor(
    public translate: TranslateService,
    private auth: AuthService,
    public router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    if(!environment.production) {
      const script = document.createElement("script");
      script.async = true;
      script.src =
        "https://www.googletagmanager.com/gtag/js?id=" + this.gtag_code;
      document.head.prepend(script);
    }

    const navEndEvent$ = this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      if (e instanceof NavigationEnd) {
        if (window.location.pathname == "dashboard") {
          gtag("event", "page_view", {
            page: "reseller-portal/dashboard",
            app_name: 'service center for channel',
            app_id: "reseller-portal",
          });
        } else if (window.location.pathname == "substrates") {
          gtag("event", "page_view", {
            page: "reseller-portal/substrates",
            app_name: 'service center for channel',
            app_id: "reseller-portal",
          });
        } else {
          gtag("event", "page_view", {
            page:  "reseller-portal" +window.location.pathname,
            app_name: 'service center for channel',
            app_id: "reseller-portal",
          });
        }
      }
    });

    this.translate.setDefaultLang('en')
    this.auth.getPreferences().subscribe(data => {
        let key = MAPPING_PRINT_OS_LANGUAGE_CONFIG_CENTER[data.general.locale]
        this.switchLanguage(key);
    })
    this.getAuthentication();
    this.GAEventsPageview();
    this.setTranslateLanguage()
  }


  setTranslateLanguage() {
    this.route.queryParams.subscribe(params => {
      if(params['select']) {
        this.switchLanguage(params['select'])
      }
    });
  }

  switchLanguage(language: string) {
    localStorage.setItem('locale', language)
    this.translate.use(language);
  }

  getAuthentication() {
    let body = {}
    localStorage.removeItem('token');
    this.auth.getAuthorized(body).subscribe(res => {
      this.resfreshToken(res.result.exp)
      this.auth.setToken(res.result.token)
      this.auth.userInformation();
      this.auth.getUserRoles()
      this.getWalkMeDetails();
    },
     (err) => {
      if(err.status === 401) {
        window.location.href = err.error.redirect_url;
      }
     }
    )
  }

  getWalkMeDetails() {
      // walkme dialog
      this.commonService.currentUserNotificaton.subscribe(res => {
        if(res.is_2in1_organization) {
          return
        }
        if(this.dialog.openDialogs.length == 0) {
          if(res && res?.new_installed_base_shoutout) {
            this.router.navigate(['/dashboard'])
          }
       }
      })
      // walkme dialog end
  }

  resfreshToken(exp) {
    let expDate
    var now = moment(new Date());
    expDate = moment(new Date(exp*1000));
    let expired = expDate.diff(now, 'seconds') * 1000
    setTimeout(() => {
     this.getAuthentication();
    }, expired)
   }

   GAEventsPageview() {
         // ga event
    this.router.events.subscribe(event => {

      if (event instanceof NavigationEnd) {
      if ( window.location.pathname == "dashboard") {
          window['ga']('set', 'page',"reseller-portal/dashboard");
      } else if ( window.location.pathname == "substrates") {
          window['ga']('set', 'page',"reseller-portal/substrates");
      } else {
          window['ga']('set', 'page',"reseller-portal"+window.location.pathname);
      }
      window['ga']('send', 'pageview');
      }
    });
   }

   get authenticated() { return this.auth.isAuthenticated }
   get isAdmin() { return this.auth.isAdmin}

   get userInformationAPIIsLoading() {
    return this.auth.userInformationAPIIsLoading() 
   }

   get isCaseDetailsRoute(): boolean {
    return /^\/cases\/[^\/]+$/.test(this.router.url);
  }
}
